import { render, staticRenderFns } from "./YAxis.vue?vue&type=template&id=69c35683&scoped=true"
import script from "./YAxis.vue?vue&type=script&lang=js"
export * from "./YAxis.vue?vue&type=script&lang=js"
import style0 from "./YAxis.vue?vue&type=style&index=0&id=69c35683&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69c35683",
  null
  
)

export default component.exports